module.exports = "<div style=\"max-height: 750px; text-align: center\">\r\n  <div *ngIf=\"beforeLunch\">\r\n    <h1>De lunch start om 12 uur!</h1>\r\n  </div>\r\n  <div *ngIf=\"live\">\r\n    <h1>De lunch is geopend!</h1>\r\n  </div>\r\n  <div *ngIf=\"lunchDone\">\r\n    <h1>De lunch is afgelopen</h1>\r\n  </div>\r\n  <canvas id=\"canvas\" style=\"max-height: 750px !important;\">{{chart}}</canvas>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Live/live.component.html
// module id = ./src/app/Live/live.component.html
// module chunks = 1